import React from 'react';
import PropTypes from 'prop-types';

import {
  BagComment,
  // Country,
  ContactContainer,
  LuggageContainer,
  Span,
  Text,
  Title,
  useContactLuggageStyles,
} from './style';

function ContactLuggage({
  bagComment, bags, customer, paxs,
}) {
  const classes = useContactLuggageStyles();
  return (
    <div className={classes.root}>
      <span>
        <Title>Contact</Title>
        <ContactContainer>
          <Text>
            <Span>Name</Span>
            {customer.name}
          </Text>
          <Text>
            <Span>Surname</Span>
            {customer.surname}
          </Text>
          <Text>
            <Span>Phone</Span>
            {customer.phone}
            {/* TODO how take the country */}
            {/* <Country>Chile</Country> */}
          </Text>
          <Text>
            <Span>Email</Span>
            {customer.email}
          </Text>
        </ContactContainer>
      </span>
      <span>
        <Title>Luggage</Title>
        <LuggageContainer>
          <Text>
            <Span>Passengers</Span>
            {paxs.length}
          </Text>
          <Text>
            <Span>Bags</Span>
            {bags}
          </Text>
          <BagComment>{bagComment}</BagComment>
        </LuggageContainer>
      </span>
    </div>
  );
}

ContactLuggage.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
  bagComment: PropTypes.string,
  bags      : PropTypes.number,
  customer  : PropTypes.shape({
    email  : PropTypes.string,
    name   : PropTypes.string,
    phone  : PropTypes.string,
    surname: PropTypes.string,
  }),
  paxs: PropTypes.arrayOf(PropTypes.shape({})),
};
ContactLuggage.defaultProps = {
  bagComment: '',
  bags      : 0,
  customer  : {
    email  : '',
    name   : '',
    phone  : '',
    surname: '',
  },
  paxs: [],
};


export default ContactLuggage;
